import React from "react";
import styled from "styled-components";

const CellWrapper = styled.div`
    padding: ${p => p.padding || "1rem"};
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;
`;

const TextDescription = styled.div`
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: ${p => p.clamp || 4};
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.4em;
    font-family: Manrope, Helvetica, sans-serif;
    white-space: normal;
    word-break: break-word;   
`;

export const TableRowCell = ({ content, clamp, padding }) => (
    <CellWrapper padding={padding}>
        <TextDescription clamp={clamp}>{content}</TextDescription>
    </CellWrapper>
);
